import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { disableBodyScrolling } from '@/utils/disableBodyScrolling';

@Component
export class FilterToggle extends ThemeComponent {
    @Prop className!: string;
    @Prop target!: string;
    @Prop({default: window.scrollY}) scrollPosition!: number;

    init() {
        // Give initial value for scrollPosition
        this.scrollPosition = window.scrollY;

        // Init click event listeners
        this.initClickEventListener();

        // Init mobile filter breakpoint check
        this.matchMedia();
    }

    initClickEventListener() {
        this.$listen(this, 'click', () => {

            // Determine whether we are opening are closing
            const closing = document.body.classList.contains('product-filters-active');

            // Check filters exists
            const filters = document.querySelector(`${this.target}`);
            if (!filters) {
                return;
            }

            // Are we closing?
            if (closing) {

                // Enable body scrolling
                this.scrollPosition = disableBodyScrolling(false, this.scrollPosition);

            // No, we're opening
            } else {

                // Disable body scrolling
                this.scrollPosition = disableBodyScrolling(true, this.scrollPosition);
            }

            // Body class
            document.body.classList.toggle('product-filters-active');

            // Filters class
            filters.classList.toggle(`${this.target}--active`);
        });
    }

    matchMedia() {
        // Remove product filters active active if greater than mobile breakpoint
        const mmBreakpoint = window.matchMedia(`(max-width: 768px)`);

        // Check breakpoint, remove product filters classes if required
        const breakpointChecker = () => {
            if (!mmBreakpoint.matches) {

                // Only run if filters are active
                if (!document.body.classList.contains('product-filters-active')) {
                    return;
                }

                // Check product filters exists
                const filters = document.querySelector(`${this.target}`);
                if (!filters) {
                    return;
                }

                // Enable body scrolling
                this.scrollPosition = disableBodyScrolling(false, this.scrollPosition);

                // Body class
                document.body.classList.remove('product-filters-active');

                // Filters class
                filters.classList.remove(`${this.target}--active`);
            }
        };

        // Init listener and initial check
        breakpointChecker();
        mmBreakpoint.addListener(breakpointChecker);
    }
}
